import React, { useState } from "react";

import * as Yup from "yup";
import { Form, Formik } from "formik";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import MuiAlert from "@material-ui/lab/Alert";
import { Typography } from "@material-ui/core";
import Snackbar from "@material-ui/core/Snackbar";

import FormikField from "components/FormikField";
import userService from "services/userService";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
export default function ForgotPassword(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [snack, setOpenSnack] = useState({
    open: false,
    severity: "",
    message: "",
  });
  const handleSubmit = async (data) => {
    try {
      await userService.createResetToken(data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);

      if (err.response) {
        console.log(err.response);
        // client received an error response (5xx, 4xx)
        if (err.response.status === 302) {
          setOpenSnack({
            open: true,
            severity: "success",
            message:
              "Request successful! Instructions on how to reset password is sent to your email.",
          });
          return;
        }
        setOpenSnack({
          open: true,
          severity: "error",
          message: `Error! ${err.response.data.message}`,
        });
      } else if (err.request) {
        setOpenSnack({
          open: true,
          severity: "error",
          message: `Error! ${err.request}`,
        });
        console.log("client never received a response, or request never left");
        // client never received a response, or request never left
      } else {
        setOpenSnack({
          open: true,
          severity: "error",
          message: `Error! ${err}`,
        });
        console.log("Other errors");
        // anything else
      }
    }
  };
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack({
      open: false,
      severity: "",
      message: "",
    });
    props.history.goBack();
  };
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "#00b28d",
        display: "grid",
        placeContent: "center",
        padding: "10vh 8vw",
      }}
    >
      <Paper style={{ padding: "60px 20px 30px", maxWidth: "300px" }}>
        <div
          style={{
            textAlign: "center",
            position: "relative",
          }}
        >
          <svg
            viewBox="0 0 650 223.8"
            style={{ marginBottom: 30, maxWidth: 200, width: "100%" }}
          >
            <g>
              <g>
                <path
                  style={{ fill: "#51A882" }}
                  d="M76.4,164.7c-2,8.2-4.7,15.6-8,22.1c2.9,1.2,5.7,2,8.2,2c26,0,37.3-31.8,37.3-57.8c0-32.4-14.3-43.5-28.5-43.5c-23,0-32,18.2-32,36.9c0,3.1,0.2,6.2,2.3,10v1.8l-17.2,2.3c-1.8-2.9-2.7-7.6-2.7-11.7c0-32.6,24.6-52.1,51.9-52.1c16.6,0,42.2,15,42.2,53.9c0,36.5-19.3,71.3-52.5,71.3c-5.9,0-10.5-1.8-14.6-3.7c-6.2,8.2-13.9,13.1-21.9,13.1c-9,0-15.8-4.7-15.8-12.9c0-9.2,7.2-18,21.3-18c2.9,0,6.4,1.2,10.2,2.7c1.4-4.1,2.5-8.8,3.9-14.1l14.4-62.5l16-2.1L76.4,164.7z M38.9,194.3c0,2.7,2,4.7,4.9,4.7c3.1,0,6.1-2.9,8.8-8.6c-2.5-1.4-5.3-2.1-7.8-2.1C41.4,188.3,38.9,190.8,38.9,194.3z M123,183.2l273.9-37.1l-2.5,10.7l-273.9,37.1L123,183.2z M183.3,147.9l-2.9,12.3c-2.5,2.1-9.8,7-21.5,7c-9.6,0-20.9-7.6-20.9-25.6c0-25.4,15.2-43.5,33-43.5c10,0,18.9,5.9,18.9,18.2c-1.4,16.8-14.4,26.9-36.3,28.7c0.8,6.8,4.5,10.3,11.7,10.3c8.2,0,14.1-4.5,17-7.4H183.3z M168.9,109.4c-7.2,0-13.7,10.7-15.2,26.2c13.3-1.6,20.7-8,20.7-19.3C174.4,112.1,172,109.4,168.9,109.4z M189.6,162.3L205.2,95l4.7-0.6l5.5,7.8c4.9-7.8,11.3-12.7,19.9-12.7c10.5,0,14.6,8.6,14.6,17.2c0,7.2-6.6,28.7-6.6,33.8c0,2.5,1.2,3.5,3.1,3.5l4.5-0.6l-1.8,7.4c-2.9,3.3-8.8,6.2-14.1,6.2c-5.3,0-9-3.5-9-9.8c0-4.7,8.2-34.8,8.2-38.9c0-4.1-1.4-6.8-4.3-6.8c-6.8,0-11.9,9.4-16.6,25.6l-7.4,33L189.6,162.3z M286.4,135.8l-2.3,10.2c-2.9,3.5-9.6,6.4-14.3,6.4c-7.4,0-11.7-5.7-11.7-12.1c0-3.5,5.9-28.5,9.6-43.3l-7.6,1l2.5-10.5l7.6-1l13.1-22.1l7.8-1.2l-4.9,21.1l12.7-1.8L296.6,93l-12.9,1.8c-6.2,27.5-9,39-9,41c0,2.3,1.6,3.9,4.3,3.9c2.3,0,4.7-1.4,6.6-3.9H286.4z M322.2,79.1c-2,8.6-12.1,50.8-12.1,52.9c0,2,0.8,2.9,2.5,2.9l5.3-0.8l-1.6,6.6c-2.5,3.9-8.6,7-13.9,7c-6.4,0-8.8-4.5-8.8-9.6c0-4.7,10-45.3,12.7-57L322.2,79.1z M306.7,69c0-6.8,7.8-9.6,14.3-9.6c3.3,0,7,1.6,7,4.7c0,6.4-8.6,9.2-14.4,9.2C310.6,73.3,306.7,71.7,306.7,69z M365.9,92.4c-3.3-3.3-9.6-7-14.3-7c-3.3,0-5.5,2.1-5.5,5.7c0,6.8,21.1,14.6,21.1,28.5c0,13.1-10,23-26.4,23c-6.1,0-14.1-4.7-17.2-8.8l2.5-11.1h1.4c4.9,5.5,11.1,8.4,15.4,8.4c5.3,0,8.6-3.5,8.6-8.2c0-8-21.5-15.4-21.5-29.1c0-11.1,8-20.1,22.5-20.1c7.4,0,13.3,3.7,16.6,7l-2.7,11.7H365.9z M402.8,119.9l-2.3,10.2c-2.9,3.5-9.6,6.4-14.3,6.4c-7.4,0-11.7-5.7-11.7-12.1c0-3.5,5.9-28.5,9.6-43.3l-7.6,1l2.5-10.5l7.6-1l13.1-22.1l7.8-1.2l-4.9,21.1l12.7-1.8L413,77.2l-12.9,1.8c-6.2,27.5-9,39.1-9,41c0,2.3,1.6,3.9,4.3,3.9c2.3,0,4.7-1.4,6.6-3.9H402.8z M406.1,155.3l26.6-115.2l-11.5,1.6l2.9-13.1l58.2-8l-2.9,13.1l-30.8,4.3l-8,35.5l20.1-2.9l-2.5,10.7L438,84l-15.8,69.1L406.1,155.3z M436.4,140.6L610,117.2l-2.5,10.9l-173.6,23.4L436.4,140.6z M494.8,55.9c-2,8.6-12.1,50.8-12.1,52.9c0,2,0.8,2.9,2.5,2.9l5.3-0.8l-1.6,6.6c-2.5,3.9-8.6,7-13.9,7c-6.4,0-8.8-4.5-8.8-9.6c0-4.7,10-45.3,12.7-57L494.8,55.9z M479.3,45.6c0-6.8,7.8-9.6,14.3-9.6c3.3,0,7,1.6,7,4.7c0,6.4-8.6,9.2-14.4,9.2C483.2,49.9,479.3,48.3,479.3,45.6z M495.2,121.1l15.6-67.4l4.7-0.6l5.5,7.8c4.9-7.8,11.3-12.7,19.9-12.7c10.5,0,14.6,8.6,14.6,17.2c0,6.4-6.6,30.7-6.6,33.8c0,2.5,1.2,3.5,3.1,3.5l4.5-0.6l-1.8,7.4c-2.9,3.3-8.8,6.2-14.1,6.2c-5.3,0-9-3.5-9-9.8c0-4.7,8.2-34.6,8.2-38.9c0-4.1-1.4-6.8-4.3-6.8c-6.4,0-11.9,9.4-16.6,25.6l-7.4,33L495.2,121.1z M609.8,16.1l15.2-2C616,53,607.2,87.9,607.2,91c0,2.1,0.8,3.5,3.3,3.5l4.9-0.6l-1.8,7.4c-3.1,2.7-8.2,6.2-14.1,6.2c-3.5,0-6.2-2.1-7.6-5.5c-3.5,5.1-8.6,8.6-15.6,8.6c-8.6,0-15.6-7-15.6-20.3c0-23.8,13.1-49.8,31.8-49.8c5.1,0,8.2,2.7,9.8,6.4L609.8,16.1z M576.8,87.3c0,7.6,2.5,11.1,5.5,11.1c3.7,0,7.8-2.7,10.5-10.2c1.4-5.9,3.1-14.3,5.3-23.2c1-5.9,0.6-13.3-5.5-13.3C585,51.8,576.8,73.5,576.8,87.3z"
                />
              </g>
            </g>
          </svg>
          <Typography align="center" variant="h5">
            Forgot Password ?
          </Typography>
          <Typography variant="caption" align="center" paragraph>
            Please enter your email address below to receive instructions on how
            reset your password.
          </Typography>
        </div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            email: "",
            // username: "jovan@dentistfind.com",
            // password: "admin123",
          }}
          validationSchema={Yup.object({
            email: Yup.string()
              .email("Email is invalid.")
              .required("This field is required."),
          })}
          onSubmit={handleSubmit}
        >
          <Form>
            <FormikField inputlabel="Email Address" name="email" />
            <Button
              style={{ marginTop: 10 }}
              variant="contained"
              size="large"
              type="submit"
              color="secondary"
              fullWidth
            >
              Submit
            </Button>
          </Form>
        </Formik>
        <Button
          style={{ marginTop: 10 }}
          onClick={() => {
            props.history.goBack();
          }}
          size="large"
          fullWidth
        >
          Back to login
        </Button>
      </Paper>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snack.open}
        autoHideDuration={6000}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity={snack.severity}>
          {snack.message}
        </Alert>
      </Snackbar>
    </div>
  );
}
